(() => {
  const destination = document.currentScript?.dataset.trioDestination;
  const perfumeDestination = document.currentScript?.dataset.trioPerfumeDestination;
  if ((!destination && !perfumeDestination) || window.replicaTrioLinksInstalled) return;
  window.replicaTrioLinksInstalled = true;
  function rewrite(scope) {
    const links = [...scope.querySelectorAll('a[href]')];
    if (scope.matches?.('a[href]')) links.push(scope);
    links.forEach(link => {
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin) return;
      if (destination && /\/products\/custom-travel-trio-body-mists\/?$/.test(url.pathname)) link.setAttribute('href', destination);
      if (perfumeDestination && /\/products\/custom-travel-trio-eau-de-parfum\/?$/.test(url.pathname)) link.setAttribute('href', perfumeDestination);
    });
  }
  rewrite(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => { if (node.nodeType === 1) rewrite(node); }))).observe(document.body, {childList:true,subtree:true});
})();
